module.exports = "<img\n    ng-if=\"LogoCtrl.companyLogoFromBackned.logo.url\"\n    src=\"{{ LogoCtrl.companyLogoFromBackned.logo.url }}\"\n    class=\"sm-logo\"\n    alt=\"\"\n/>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/auth/logo/logo.html
// module id = 507
// module chunks = 0